import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    {/* 09-api-summary.md */}
    <h1 {...{
      "id": "adobe-stock-api-reference"
    }}>{`Adobe Stock API reference`}</h1>
    <h2 {...{
      "id": "api-endpoints"
    }}>{`API endpoints`}</h2>
    <p>{`The API provides the following endpoints in the `}<inlineCode parentName="p">{`https://stock.adobe.io/Rest`}</inlineCode>{` namespace:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Endpoint`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Purpose`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/11-search-reference.md"
            }}>{`/Media/1/Search/Files`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Find, filter, sort, and paginate assets from Adobe Stock.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/19-bulk-metadata-files-reference.md"
            }}>{`/Media/1/Files`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get metadata for selected assets, one at time or in bulk.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/17-categorytree.md"
            }}>{`/Media/1/Search/CategoryTree`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get information on Stock categories and sub-categories.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/12-licensing-reference.md"
            }}>{`/Libraries/1/Content/Info`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get licensing status information about an asset.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/12-licensing-reference.md"
            }}>{`/Libraries/1/Content/License`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Request a license for an asset for your user.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/12-licensing-reference.md"
            }}>{`/Libraries/1/Member/Profile`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get information about your user's purchasing/licensing status.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/13-license-history.md"
            }}>{`/Libraries/1/Member/LicenseHistory`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get a list of past purchases and download links.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "additional-topics"
    }}>{`Additional topics`}</h2>
    <p>{`This reference also provides the following information:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Topic`}</strong></th>
          <th parentName="tr" {...{
            "align": null
          }}><strong parentName="th">{`Content`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/10-headers-for-api-calls.md"
            }}>{`Headers`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of required and optional headers for all calls to the Adobe Stock API.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "/stock/docs/api/14-locale-codes.md"
            }}>{`Locales`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of all valid locale codes for localization.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      